export default "__VITE_ASSET__Cd93wvpY__"